var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"getvalidate",class:{gray: (!_vm.stop)}},[_c('span',{staticClass:"hovers",on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.stop ? '获取验证码' : ("（" + _vm.mytimer + "）秒后重新获取")))])])}
var staticRenderFns = []

export { render, staticRenderFns }